import { useEffect, useState } from "react";
import { getCountryName } from "../../countries";
import styles from "../Profile.module.css";
import AddProfilePic from "./AddProfilePic";
import Popup from "../../../components/ui/popup";
import Link from "next/link";
// import { FaCameraRetro } from 'react-icons/fa';
import { FaFacebookF } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaInfinity } from "react-icons/fa";
import useTranslation from "next-translate/useTranslation";
import {
  DAYLY_LEAGUE_GAMES,
  DAYLY_ANALYZES,
  GAMES_DATABASE,
  TIERS,
  UNLIMITED_TIER,
  FREE_TIER,
  AvatarTypes,
} from "@chesshotel/constants";
import { useMembership } from "../../../redux/membership";
import { useUser, setAvatarId, setAvatarUpload } from "../../../redux/user";
import UserAvatar from "../../UserAvatar";
import { setLoadingBar } from "../../../redux/siteData";
import { api } from "../../../services/api";
import { useRouter } from "next/router";
import FBScript from "@/components/util/fb-script";
import { Button } from "@/components/ui/button";

export function updateAvatarId(avatarId: number) {
  setLoadingBar(true);
  api
    .post("/users/avatarId", { avatarId })
    .then(() => {
      setAvatarId(avatarId);
    })
    .catch(() => {
      console.error("updateAvatarId fail");
    })
    .then(() => {
      console.log("updateAvatarId done");
      setLoadingBar(false);
    });
}

export function uploadAvatar(data: FormData) {
  setLoadingBar(true);
  api
    .post("/users/avatar-image", data)
    .then(() => {
      setAvatarUpload();
    })
    .catch(() => {})
    .then(() => {
      setLoadingBar(false);
    });
}

function deletePlan(router) {
  setLoadingBar(true);

  api
    .get("/stripe/delete")
    .then((response) => {
      setLoadingBar(false);
      router.push("/membership-done");
    })
    .catch(() => {
      setLoadingBar(false);
    });
}

export default function Membership() {
  const { t } = useTranslation("common");
  const { t: authT } = useTranslation("auth");
  const { t: commonT } = useTranslation("common");

  const router = useRouter();

  const { username, created, country, avatarType } = useUser();
  const { tier } = useMembership();

  let dateStr = "";
  if (created) {
    const date = new Date(created);
    dateStr =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
  }

  const [showAddProfilePic, setShowAddProfilePic] = useState(false);
  const [showAreYouSure, setShowAreYouSure] = useState(false);

  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [formData, setFormData] = useState(null);

  const [uploadOpen, setUploadOpen] = useState(false);
  const [avatarOpen, setAvatarOpen] = useState(false);

  useEffect(() => {
    if (avatarType !== AvatarTypes.UPLOAD) {
      setImagePreviewUrl(null);
    }
  }, [avatarType]);

  const tierStr = TIERS[tier];
  const leagueGamesStr =
    tier === UNLIMITED_TIER ? <FaInfinity /> : DAYLY_LEAGUE_GAMES[tier];
  const analyzesStr =
    tier === UNLIMITED_TIER ? <FaInfinity /> : DAYLY_ANALYZES[tier];
  const gamesDatabaseStr =
    tier === UNLIMITED_TIER ? <FaInfinity /> : authT(GAMES_DATABASE[tier]);

  function handleImageChange(e) {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = async () => {
      const str: string = reader.result.toString();
      setImagePreviewUrl(str);

      const data = new FormData();
      data.append("file", file);
      setFormData(data);
      setUploadOpen(true);
    };

    reader.readAsDataURL(file);
  }

  function renderAreYouSure() {
    return (
      <div className={styles.areYouSure}>
        {t("Are you sure?")}
        <div className={styles.yesNo}>
          <button
            className="btn btn-base btn-blue"
            onClick={() => deletePlan(router)}
          >
            {t("Yes")}
          </button>
          <button
            className="ml-2 btn btn-base btn-outline"
            onClick={() => setShowAreYouSure(false)}
          >
            {t("No")}
          </button>
        </div>
      </div>
    );
  }

  function renderButtons() {
    if (tier === FREE_TIER) {
      return (
        <div className={styles.buttonCont}>
          <Link href="/memberships">
            <button className="btn btn-base btn-red">{t("Get premium")}</button>
          </Link>
        </div>
      );
    } else {
      return (
        <div className={styles.buttonCont}>
          <Link href="/memberships">
            <button className="btn btn-base btn-blue">
              {authT("Change membership")}
            </button>
          </Link>

          <a href="https://billing.stripe.com/p/login/9AQaFk4qu5ug8ve6oo">
            <button className="btn btn-base btn-blue">
              {authT("Manage subscription")}
            </button>
          </a>

          <button
            className="btn btn-base btn-outline"
            onClick={() => setShowAreYouSure(true)}
          >
            {authT("Cancel membership")}
          </button>
        </div>
      );
    }
  }

  function renderDefaultAvatars() {
    const avatarIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    return (
      <Popup
        title={authT("Choose avatar")}
        onClose={() => setAvatarOpen(false)}
      >
        <div className="flex flex-wrap">
          {avatarIds.map((avatarId) => {
            return (
              <div
                className={`relative m-4 rounded-full cursor-pointer hover:opacity-70`}
                onClick={() => {
                  setAvatarOpen(false);
                  updateAvatarId(avatarId);
                }}
                key={avatarId}
              >
                <img
                  className={`inline-block w-20 h-20`}
                  src={`/static/avatars/${avatarId}.svg`}
                  alt="avatar"
                />
              </div>
            );
          })}
        </div>
        <div className="flex justify-end items-center pt-4 mt-4 w-full">
          <button
            className="btn btn-base btn-outline"
            onClick={() => setAvatarOpen(false)}
          >
            {t("Cancel")}
          </button>
        </div>
      </Popup>
    );
  }

  function renderUploadModal() {
    function handleOnClose() {
      setFormData(null);
      setImagePreviewUrl(null);
      setUploadOpen(false);
    }

    return (
      <Popup title={authT("Upload image?")} onClose={handleOnClose}>
        <Button
          variant="default"
          size="wide"
          onClick={() => {
            handleOnClose();
            uploadAvatar(formData);
          }}
        >
          {authT("Upload image")}
        </Button>
        <Button
          variant="outline"
          size="wide"
          className="ml-3"
          onClick={() => handleOnClose()}
        >
          {t("Cancel")}
        </Button>
      </Popup>
    );
  }

  return (
    <div className={styles.statsBody}>
      <FBScript />
      {showAddProfilePic && (
        <AddProfilePic onClose={() => setShowAddProfilePic(false)} />
      )}
      {uploadOpen && renderUploadModal()}
      {avatarOpen && renderDefaultAvatars()}
      <div className={styles.stats}>
        <div className={styles.avatarCont}>
          <div className={styles.avatar}>
            {imagePreviewUrl ? (
              <img
                className="w-32 h-32 rounded-full border border-gray-200"
                src={imagePreviewUrl}
              />
            ) : (
              <UserAvatar className="w-32 h-32" />
            )}
          </div>
          <div className="flex items-center self-end p-2 space-x-1">
            {/* <IconButton
              cursor="pointer" onClick={() => { }}
              size="xs" aria-label={'Webcam'} icon={<FaCameraRetro />} >
            </IconButton> */}
            <span className="has-tooltip">
              <span className="tooltip">{authT("Upload image")}</span>
              <label
                htmlFor="file-upload"
                className="bg-gray-100 cursor-pointer btn btn-icon btn-icon-sm btn-goast"
              >
                <FaUpload />
              </label>
            </span>
            <input
              style={{ display: "none" }}
              id="file-upload"
              type="file"
              accept=".png,.jpg,.jpeg"
              onChange={(e) => handleImageChange(e)}
            />
            <span className="has-tooltip">
              <span className="tooltip">{authT("Choose avatar")}</span>
              <button
                className="bg-gray-100 btn btn-icon btn-icon-sm btn-goast"
                onClick={() => setAvatarOpen(true)}
              >
                <FaUser />
              </button>
            </span>
            <span className="has-tooltip">
              <span className="tooltip">{authT("Choose facebook avatar")}</span>
              <button
                className="bg-gray-100 btn btn-icon btn-icon-sm btn-goast"
                onClick={() => setShowAddProfilePic(true)}
              >
                <FaFacebookF />
              </button>
            </span>
          </div>
          <div className={styles.username}>{username}</div>
        </div>
        <div className={styles.userInfo}>
          {created && (
            <div className={styles.infoCont}>
              <div className={styles.infoTitle}>{authT("Member since")}</div>
              <div className={styles.infoValue}>{dateStr}</div>
            </div>
          )}
          {/* {country && (
            <div className={styles.infoCont}>
              <div className={styles.infoTitle}>{t("Country")}</div>
              <div className={styles.infoValue}>{getCountryName(country)}</div>
            </div>
          )} */}
          <div className={styles.infoCont}>
            <div className={styles.infoTitle}>
              {authT("Current membership")}
            </div>
            <div className={styles.infoValue}>{tierStr}</div>
          </div>
          <div className={styles.infoCont}>
            <div className={styles.infoTitle}>
              {authT("League games / day")}
            </div>
            <div className={styles.infoValue}>{leagueGamesStr}</div>
          </div>
          <div className={styles.infoCont}>
            <div className={styles.infoTitle}>
              {commonT("Game reviews / day")}
            </div>
            <div className={styles.infoValue}>{analyzesStr}</div>
          </div>
          <div className={styles.infoCont}>
            <div className={styles.infoTitle}>{authT("Games database")}</div>
            <div className={styles.infoValue}>{gamesDatabaseStr}</div>
          </div>
        </div>
      </div>
      {renderButtons()}
      {showAreYouSure && renderAreYouSure()}
    </div>
  );
}
